export const sharedUsersConstants = {
  termsFilter: 'latest',
};
